import { checkDiff } from '../../../../../utils/formValidation/errorCheckingFunctions';

import {
    validateEmploymentTypeId,
    validateHourlyPay,
    validateHoursPerWeek,
    validateStartDate
} from './validationFunctions';

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    newErrors = validateHourlyPay(newEntry.hourlyPay, newErrors);
    newErrors = validateEmploymentTypeId(newEntry.employmentTypeId, newErrors);
    newErrors = validateStartDate(newEntry.startDate, newErrors, true);
    newErrors = validateHoursPerWeek(
        newEntry.hoursPerWeek,
        newEntry.hoursPerWeekId,
        newErrors,
        newEntry.fixedFlexibleHour
    );

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
